import { render, staticRenderFns } from "./bnp-bankguarantee-overview.vue?vue&type=template&id=406bf0e3"
import script from "./bnp-bankguarantee-overview.vue?vue&type=script&lang=ts"
export * from "./bnp-bankguarantee-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports